import { render } from "./FeedbackModal.vue?vue&type=template&id=241941a9"
import script from "./FeedbackModal.vue?vue&type=script&lang=js"
export * from "./FeedbackModal.vue?vue&type=script&lang=js"

import "./FeedbackModal.vue?vue&type=style&index=0&id=241941a9&lang=css"

import exportComponent from "E:\\Dokumenty\\Projekty\\boost-rpg-tools\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__